import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "selectedOption",
    "option",
    "options",
    "hiddenInput",
    "selected",
    "form"
  ];

  connect() {
    document.addEventListener("click", this.handleOutsideClick.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick.bind(this));
  }

  selectOption({ params, target }) {
    const selectedOptionText = target.textContent;
    this.selectedOptionTarget.textContent = selectedOptionText;
    this.hiddenInputTarget.value = params.value;
    this.toggleOptions();
    this.toggleSelectionAttribute(target);
    this.formTarget.submit();
  }
  
  toggleSelectionAttribute(target) {
    target.setAttribute("data-custom-filter-dropdown-target", "option selected");
    target.classList.add("selected");
    this.selectedTarget.classList.remove("selected");
    this.selectedTarget.setAttribute("data-custom-filter-dropdown-target", "option");
    console.log(this.selectedTarget)
  }
  
  toggleOptions() {
    const optionsElement = this.optionsTarget;
    optionsElement.style.display = optionsElement.style.display === "none" ? "block" : "none";
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.optionsTarget.style.display = "none";
    }
  }
}
